import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-priority-feed')
  .service(
    'submitStudentFeedbackCommand',
    function submitStudentFeedbackCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      log: any
    ) {
      return defineCommandORM(
        'submitStudentFeedbackCommand',
        function submitStudentFeedbackCommand(deferred, studentFeedbackFormData) {
          $http
            .post(`api/v1/core/studentfeedback/`, studentFeedbackFormData)
            .then(({ data }) => {
              log.user.success(`Your feedback was successfully submitted.`);
              deferred.resolve(data);
            })
            .catch(() => {
              log.user.issue(`Your feedback failed to send. Sorry please try again.`);
              deferred.reject('Failed to send feedback, please attempt again');
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/submit_student_feedback_command.ts